import { DropdownItem } from '@shared/abstraction';
import { Client } from '../models';

export const mapDropdownFromClient = (clients: Client[]): DropdownItem[] => {
  return clients
    .filter((client: Client) => client.isActive)
    .map<DropdownItem>(({ id, name }: Client) => {
      return {
        label: name,
        value: id,
      };
    });
};
